import SiteDevicesTable from '@/features/devices/SiteDevicesTable';
import useAuth from '@/shared/context/auth-context';
import { FunctionComponent, ReactElement } from 'react';
import { useParams } from 'react-router-dom';

const SiteDevices: FunctionComponent = (): ReactElement => {
	const { siteId } = useParams();
	const { user } = useAuth();

	return <SiteDevicesTable siteId={siteId} customerName={user?.customer?.name} />;
};

export default SiteDevices;
